import {rwbApi} from '../apis/api';

export const deletePost = (streamID, eventID, challengeID, groupID) => {
  if (eventID) {
    return rwbApi.deleteEventPost(eventID, streamID);
  } else if (challengeID) {
    return rwbApi.deleteChallengePost(challengeID, streamID);
  } else if (groupID) {
    return rwbApi.deleteGroupPost(groupID, streamID);
  } else {
    return rwbApi.deleteUserPost(streamID);
  }
};
